import axios from '@/plugins/axios';
import { useToast } from '@/composables/use-toast';

const { addToast } = useToast();

const BASE_URL = '/api/queue-management';

const validQueueTypes = [ 'eval-runs', 'leaderboard' ];

function validateQueueType(queueType) {
  try {
    if (!validQueueTypes.includes(queueType)) {
      throw new Error(`Invalid queue type: ${queueType}. Must be one of: ${validQueueTypes.join(', ')}`);
    }
  } catch (error) {
    addToast(error.message, 'error');
    throw error;
  }
}

export const getStats = async (queueType) => {
  try {
    validateQueueType(queueType);
    const response = await axios.get(`${BASE_URL}/${queueType}/stats`);
    return response.data;
  } catch (error) {
    console.error('Error getting stats:', error);
    return null;
  }
}

export const cleanQueue = async (queueType) => {
  try {
    validateQueueType(queueType);
    const response = await axios.post(`${BASE_URL}/${queueType}/queue/clean`, {});
    return response.data;
  } catch (error) {
    console.error('Error cleaning queue:', error);
    return null;
  }
}

export const resetSemaphore = async (queueType) => {
  try {
    validateQueueType(queueType);
    const response = await axios.post(`${BASE_URL}/${queueType}/semaphore/reset`, {});
    return response.data;
  } catch (error) {
    console.error('Error resetting semaphore:', error);
    return null;
  }
}

export const releaseSlot = async (queueType, id) => {
  try {
    validateQueueType(queueType);
    const response = await axios.post(`${BASE_URL}/${queueType}/semaphore/release`, { id });
    return response.data;
  } catch (error) {
    console.error('Error releasing slot:', error);
    return null;
  }
}
